var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaretDownGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.11458 0.24375L5.34794 3.47712L8.58128 0.24375C8.90628 -0.08125 9.43128 -0.08125 9.75628 0.24375C10.0813 0.56875 10.0813 1.09378 9.75628 1.41878L5.93128 5.24378C5.60628 5.56878 5.08128 5.56878 4.75628 5.24378L0.93125 1.41878C0.60625 1.09378 0.60625 0.56875 0.93125 0.24375C1.25625 -0.0729167 1.78958 -0.08125 2.11458 0.24375Z",
    fill: "#8D8D99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDownGrey);
export default __webpack_public_path__ + "static/media/caret-down-grey.187343fba4413ffbb02482f41f232431.svg";
export { ForwardRef as ReactComponent };